import { Suspense } from 'react';
import { GetCart } from './CartHandler';
import { formatter } from '../../utils/common.js'
import { useState, useEffect } from 'react';
import axios from 'axios';
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import AddressModal from './AddressModal.js';
import "./addressModal.css"


const apiUrl = process.env.REACT_APP_BASEURL;

function AddressBlock(props) {

    const token = useState(props.token.token);
    const customer = useState(token.customerName);
    const cart = GetCart();
    const [billingAddress, setBillingAddress] = useState({})
    const [shippingAddress, setShippingAddress] = useState({})
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [billingValue, setBillingValue] = React.useState('e');
    const [expanded, setExpanded] = useState(false);
    const [shippingExpanded, setShippingExpanded] = useState(false);

    const shippingAddData = [
        "near 23425 south", 'far 3463 north', 'so close 2534 center', 'near by 4535 downtown'
    ]
    const billingAddData = [
        "st louis", 'st charles', 'st peters', 'chesterfield'
    ]
    const [shippingAdd, setShippingAdd] = useState(shippingAddData[0])
    const [billingAdd, setBillingAdd] = useState(billingAddData[0])
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    const billingHandleChange = (event) => {
        setBillingValue(event.target.value);
    };

    useEffect(() => {
        getBillingAddress();
        getShippingAddress();
    }, []);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };

      const closeAccordion = () => {
        setExpanded(false);
      };
    const handleAccordionSh= (pane2) => (event, isExpanded) => {
        setShippingExpanded(isExpanded ? pane2 : false);
      };

      const handleShippingClose = () => {
        setShippingExpanded(false);
      };

    const testShippingAddress = () => {
        if (shippingAddData.length !== 0) {
            return (
                <ul>
                    <div className='radio-cover'>
                        <div className='flex'>
                            <Radio
                                onChange={handleChange}
                                onClick={() => setShippingAdd(shippingAddData[0])}
                                checked={selectedValue === 'a'}
                                value="a"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'A' }}
                            />
                            <li className='cursor-pointer lg:mt-2 w-[8rem]'  >{shippingAddData[0]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[1])}
                                checked={selectedValue === 'b'}
                                onChange={handleChange}
                                value="b"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[1]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[2])}
                                checked={selectedValue === 'c'}
                                onChange={handleChange}
                                value="c"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'C' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[2]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[3])}
                                checked={selectedValue === 'd'}
                                onChange={handleChange}
                                value="d"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'D' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[3]}</li>

                        </div>

                    </div>
                </ul>
            )
        } else {
            return (
                <div>Error Appeared!</div>
            )
        }
    }
    const testBillingAddress = () => {
        if (shippingAddData.length !== 0) {
            return (
                <ul>
                    <div className='radio-cover'>
                        <div className='flex'>
                            <Radio
                                onChange={billingHandleChange}
                                onClick={() => setBillingAdd(billingAddData[0])}
                                checked={billingValue === 'e'}
                                value="e"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'E' }}
                            />
                            <li className='cursor-pointer lg:mt-2 w-[3rem]'  >{billingAddData[0]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[1])}
                                checked={billingValue === 'f'}
                                onChange={billingHandleChange}
                                value="f"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'F' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[1]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[2])}
                                checked={billingValue === 'g'}
                                onChange={billingHandleChange}
                                value="g"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'G' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[2]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[3])}
                                checked={billingValue === 'h'}
                                onChange={billingHandleChange}
                                value="h"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'H' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[3]}</li>

                        </div>

                    </div>
                </ul>
            )
        } else {
            return (
                <div>Error Appeared!</div>
            )
        }
    }


    const getBillingAddress = () => {

        axios
            .get(apiUrl + `/api/Users/GetBillingAddress`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {
                setBillingAddress(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getShippingAddress = () => {
        axios
            .get(apiUrl + `/api/Users/GetShippingAddress`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {
                setShippingAddress(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const billingAddressReturn = () => {
        if (!billingAddress.address1) {
            return (
                <>
                    <div className='lg:mt-2'>
                        Getting your billing address....
                    </div>
                </>
            );
        } else {
            return (
                <>

                    <Suspense fallback={<h2>Loading...</h2>}>
                        <div className='flex'>
                            <label className='lg:mt-2'>
                                {billingAddress.address1.trim() + ', '}
                                {!!billingAddress.address2 && !!billingAddress.address2.trim() ? billingAddress.address2 + ', ' : null}
                                {billingAddress.city + ', '}
                                {billingAddress.state + ' '}
                                {billingAddress.zip}
                            </label>
                        </div>
                    </Suspense>
                </>
            );
        }
    }

    const shippingAddressReturn = () => {
        if (!shippingAddress.address1) {
            return (
                <>
                    <div className='lg:mt-2'>
                        Getting your shipping address....
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <Suspense fallback={<div>Loading...</div>}>
                        <div className='flex'>
                            <label className='lg:mt-2'>
                                {shippingAddress.address1 + ', '}
                                {!!shippingAddress.address2 && !!billingAddress.address2 ? shippingAddress.address2 + ', ' : null}
                                {shippingAddress.city + ', '}
                                {shippingAddress.state + ' '}
                                {shippingAddress.zip}
                            </label>
                        </div>
                    </Suspense>
                </>
            );
        }
    }

    const handleShippingSelect = () => {
        setBillingAddress(shippingAddData[1])
    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div id="ch1-1" className=" col-2">
            <h3>{customer}</h3>
            <div className=" ch-title-cover">
                <div className='flex-row'>
                    <strong className='ml-2 mt-2'>Billing Address</strong>
                    <div className='ml-2 lg:mt-0 bil-txt'>{billingAddress ? billingAddressReturn() : null}</div>
                </div>
                <div className='flex-row w-[26rem]'>
                    <strong className='lg:ml-[4rem] mt-2'>Shipping Address</strong>
                    <div className='ml-2 lg:mt-0 shi-txt'>{shippingAddress ? shippingAddressReturn() : null}</div>
                </div>
            </div>
            <div className='lg:w-[44.5rem]'>
                <div>
                    {/* <Accordion defaultExpanded>
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <div className='flex gap-[10rem]'>
                                <label>
                                    {billingAddress.address1 + ', '}
                                    {!!billingAddress.address2 && !!billingAddress.address2 ? billingAddress.address2 + ', ' : null}
                                    {billingAddress.city + ', '}
                                    {billingAddress.state + ' '}
                                    {billingAddress.zip}
                                </label>
                                <label>
                                    {shippingAddress.address1 + ', '}
                                    {!!shippingAddress.address2 && !!billingAddress.address2 ? shippingAddress.address2 + ', ' : null}
                                    {shippingAddress.city + ', '}
                                    {shippingAddress.state + ' '}
                                    {shippingAddress.zip}
                                </label>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='flex gap-[6rem]'>
                                <div>
                                    {billingAddress === null ? 'Loading...' : billingAddressReturn()}
                                </div>
                                <div>
                                    {shippingAddress === null ? 'Loading...' : shippingAddressReturn()}
                                </div>
                            </div>

                        </AccordionDetails>

                    </Accordion> */}
                </div>
                <div className='flex gap-1'>
                    <div className='lg:w-[22rem] w-10rem]'>
                        <Accordion expanded={expanded === "panel1"} onChange={handleAccordionChange('panel1')}>
                            <AccordionSummary
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div className='relative lg:left-[17.8rem] lg:bottom-3 font-bold change1'>
                                    change
                                </div>
                                <div>
                                <div>Michael Hollingsworth</div>
                                <div className='flex-col'>
                                    {billingAdd}
                                </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div >{testBillingAddress()}</div>
                            </AccordionDetails>
                            <AccordionActions>
                                <Button  onClick={closeAccordion}>Save</Button>
                                <Button onClick={handleOpen}>Add</Button>
                            </AccordionActions>
                        </Accordion>

                    </div>
                    <div className='lg:w-[22rem] w-[10rem]'>
                        <Accordion expanded={shippingExpanded === "panel2"} onChange={handleAccordionSh('panel2')} >
                            <AccordionSummary
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div className='relative lg:left-[17.8rem] lg:bottom-3 font-bold change2'>
                                    change
                                </div>
                                <div>
                                <div>Michael Hollingsworth</div>
                                <div className='flex-col'>
                                    {shippingAdd}
                                </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div >{testShippingAddress()}</div>
                            </AccordionDetails>
                            <AccordionActions>
                                <Button className='ad-save' onClick={handleShippingClose}>Save</Button>
                                <Button className='ad-add' onClick={handleOpen}>Add</Button>
                            </AccordionActions>
                        </Accordion>

                    </div>

                </div>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <div className='flex-col'>
                            <strong>Payment Method Selected</strong>
                            <p className='lg:ml-5 lg:mt-2'><strong className='mr-2'>Master Card</strong>Ending 2145</p>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Your payment methods will be added here!
                    </AccordionDetails>
                </Accordion>
                <div className="table-wrapper">
                    <table className="table table-striped table-bordered table-extra">
                        <thead>
                            <tr>
                                <th className="number">Item Number</th>
                                <th className="price">Price</th>
                                <th className="quantity">Quantity</th>
                                <th className="quantity">Lot #</th>
                                <th className="quantity">Roll #</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.map(item =>
                                <tr key={item.ItemNumber}>
                                    <td>{item.ItemNumber}</td>
                                    <td>{formatter.format(item.Price)}</td>
                                    <td>{item.Quantity}</td>
                                    <td>{"empty"}</td>
                                    <td>{"empty"}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {<AddressModal handleClose={handleClose} handleOpen={handleOpen} open={open} />}
        </div>
    );
}




//class AddressBlock extends React.Component {
// constructor() {
//     super();
//     this.state = {
//         name: 'React',            
//         billingAddress: null,
//         shippingAddress: null,
//         customer: ""
//     };
// }

// async componentDidMount() {
//     const tokenString = sessionStorage.getItem("token");
//     const token = JSON.parse(tokenString);

//     this.setState({ customer: token.customerName });

//     let headers = new Headers({
//         "Accept": "application/json",
//         "Content-Type": "application/json",
//         'Authorization': 'Bearer ' + token.token
//     });

//     const bresponse = await fetch(apiUrl + `/api/Users/GetBillingAddress`, {
//         method: "GET",
//         headers: headers
//     });
//     const bjson = await bresponse.json();
//     console.log(bjson);
//     this.setState({ billingAddress: bjson });

//     const sresponse = await fetch(apiUrl + `/api/Users/GetShippingAddress`, {
//         method: "GET",
//         headers: headers
//     });
//     const sjson = await sresponse.json();
//     console.log(sjson);
//     this.setState({ shippingAddress: sjson });
// }

// render() {
//     const billingAddress = this.state.billingAddress;
//     const shippingAddress = this.state.shippingAddress;
//     const cart = GetCart();

//      function GetBillingAddress() {
//             return (
//                 <>
//                     <strong>Billing: </strong>
//                     <Suspense fallback={<div>Loading...</div>}>
//                         <label>
//                             {billingAddress.address1.trim() + ', '}
//                             {!!billingAddress.address2 && !!billingAddress.address2.trim() ? billingAddress.address2 + ', ' : null}
//                             {billingAddress.city + ', '}
//                             {billingAddress.state + ' '}
//                             {billingAddress.zip}
//                         </label>
//                     </Suspense>
//                 </>
//             );
//         }

//         function GetShippingAddress() {
//             return (
//                 <>
//                     <strong>Shipping: </strong>
//                     <Suspense fallback={<div>Loading...</div>}>
//                         <label>
//                             {shippingAddress.address1.trim() + ', '}
//                             {!!shippingAddress.address2 && !!billingAddress.address2.trim() ? shippingAddress.address2 + ', ' : null}
//                             {shippingAddress.city + ', '}
//                             {shippingAddress.state + ' '}
//                             {shippingAddress.zip}
//                         </label>
//                     </Suspense>
//                 </>
//             );
//         }

//         return (
//             <div id="checkout" className="block col-2">
//                 <h3>{this.state.customer}</h3>
//                 <div className="row">
//                     <div>
//                         {billingAddress === null ? 'Loading...' : GetBillingAddress()}
//                     </div>
//                     <div>
//                         {shippingAddress === null ? 'Loading...' : GetShippingAddress()}
//                     </div>
//                 </div>
//                 <div>
//                 <div className="table-wrapper">
//                     <table className="table table-striped table-bordered table-extra">
//                         <thead>
//                             <tr>
//                                 <th className="number">Item Number</th>
//                                 <th className="price">Price</th>
//                                 <th className="quantity">Quantity</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {cart.map(item =>
//                                 <tr key={item.ItemNumber}>
//                                     <td>{item.ItemNumber}</td>
//                                     <td>{formatter.format(item.Price)}</td>
//                                     <td>{item.Quantity}</td>                                    
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }
export default AddressBlock;
